<template lang="pug">
.label(v-if="label") {{ label }}
FormField(v-slot="$field" :name="name")
  Select.w-full(v-model="$field.value" :options="dropdownOptions" filter optionLabel="name" optionValue="code" placeholder="--Select Destination Guide--")
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Select        from 'primevue/select';
import Message       from 'primevue/message';
import { FormField } from '@primevue/forms';
import { dropdownOptionsApi }   from '@/api'

const dropdownOptions = ref([])

const props = defineProps({
  name:   { type: String, required: true, default: 'fieldName' },
  label:  { type: String, required: false, default: 'field' },
  resource: { type: Object, default: null }
})

onMounted(() => {
  let params = {}

  if (props.resource) {
    params.resourceType = props.resource.className
    params.resourceId   = props.resource.id
  }
  dropdownOptionsApi.getDestinationGuides(params)
    .then(response => {
      dropdownOptions.value = response.data
      dropdownOptions.value.unshift({code: null, name: '--Select Destination Guide--'})
    })
})
</script>